import { Staff_DropInClinicRequestStatus as DropInClinicRequestStatus } from 'src/generated/gql/graphql';

/** A patient is "active" if they're somewhere in the process — waiting, talking to someone, etc.*/
export const activeStatuses = new Set([
  DropInClinicRequestStatus.Submitted,
  DropInClinicRequestStatus.CheckingIn,
  DropInClinicRequestStatus.CheckedIn,
  DropInClinicRequestStatus.Prepared,
  DropInClinicRequestStatus.Preparing,
  DropInClinicRequestStatus.Accepted,
]);

export const isInactiveStatus = (status: DropInClinicRequestStatus): boolean => {
  return !activeStatuses.has(status);
};
